

import React from 'react';
import Row from 'react-bootstrap/Row';

export default function returnHeader(stage, provider, brand) {
    if (stage === "CREATE"){
        return CreateHeader
    } else if (stage === "PASSWORD"){
        return PasswordHeader
    } else if (stage === "EXISTS"){
        return ExistsHeader
    } else if (stage === "COMPLETE"){
        return CompleteHeader
    } else if (stage === "FINISH-SOCIAL") {
        if (provider === "facebook"){
            if (brand === "TO"){
                return FinishSocialFacebookTO
            } else {
                return FinishSocialFacebook
            }
        } else if (provider === "google"){
            if (brand === "TO"){
                return FinishSocialGoogleTO
            } else {
                return FinishSocialGoogle
            }
        }
        
    }
}

const CreateHeader =
<div>
    <Row className = "justify-content-center">
        <h1 className = "title__TO left">Create your account</h1>
    </Row>
    <Row className = "justify-content-center sso-spacing">
        <p>You can use your My Lexus or My Toyota or SmartPath account information to log in.</p>
    </Row>
    <Row className = "justify-content-center step-message">
        <div>Step 1 of 2</div>
    </Row>
</div>

const PasswordHeader =
<div>
    <Row className = "justify-content-center">
        <h1 className = "title__TO left">Create a password</h1>
    </Row>
    <Row className = "justify-content-center sso-spacing">
        <p>You can use your My Lexus or My Toyota or SmartPath account information to log in.</p>
    </Row>
    <Row className = "justify-content-center step-message">
        <div>Step 2 of 2</div>
    </Row>
</div>

const ExistsHeader =
<div>
    <Row className = "justify-content-center">
        <h1 className = "title__TO left">Error creating account!</h1>
    </Row>
</div>

const CompleteHeader =
<div>
    <Row className = "justify-content-center">
        <h1 className = "title__TO left">Complete your registration</h1>
    </Row>
    <Row className = "justify-content-center">
        <p className = "small-font register-complete-header">You'll soon be sent an email with a link to complete your registration</p>
    </Row>
</div>

const FinishSocialFacebook = 
<div>
    <Row className = "justify-content-center location">
        <div>Facebook Sign In</div>
    </Row>
    <Row className = "justify-content-center">
        <div className = "title__TO left">Please Provide Your Contact Details</div>
    </Row>
    <Row className = "justify-content-center message__TO left">
        You're one step away from accessing your My Toyota account. Please provide your contact information below to sign in.
    </Row>
</div>
const FinishSocialGoogle = 
<div>
    <Row className = "justify-content-center location">
        <div>Google Sign In</div>
    </Row>
    <Row className = "justify-content-center">
        <div className = "title__TO left">Please Provide Your Contact Details</div>
    </Row>
    <Row className = "justify-content-center message__TO left">
        You're one step away from accessing your My Toyota account. Please provide your contact information below to sign in.
    </Row>
</div>

const FinishSocialFacebookTO = 
<div>
    <Row className = "justify-content-center location">
        <div>Facebook Sign In</div>
    </Row>
    <Row className = "justify-content-center">
        <div className = "title__TO left">Please Provide Your Contact Details</div>
    </Row>
    <Row className = "justify-content-center message__TO left">
        You're one step away from accessing your My Toyota account. Please provide your contact information below to sign in.
    </Row>
</div>
const FinishSocialGoogleTO = 
<div>
    <Row className = "justify-content-center location">
        <div>Google Sign In</div>
    </Row>
    <Row className = "justify-content-center">
        <div className = "title__TO left">Please Provide Your Contact Details</div>
    </Row>
    <Row className = "justify-content-center message__TO left">
        You're one step away from accessing your My Toyota account. Please provide your contact information below to sign in.
    </Row>
</div>